module.exports = __webpack_public_path__ + "static/media/prontuario.2bc4409c.png";